function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD228",
  d: "M2499.78 345.07C2499.668 154.539 2345.24.11 2154.71 0H345.07C154.539.11.11 154.539 0 345.07v1809.64c.11 190.53 154.539 344.959 345.07 345.07h1809.64c190.53-.111 344.959-154.54 345.07-345.07V345.07z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E42815",
  d: "M1440.273 1155.848h353.619L1249.89 1699.8l-544.002-543.902h353.618V599.947h380.767v555.901zm-1015.31 693.989h1649.854v99.99H424.962v-99.99z"
}));

var SvgDocusignIco = function SvgDocusignIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 2500 2500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocusignIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/docusign_ico.d389f64f.svg";
export { ForwardRef as ReactComponent };